module.exports = __webpack_public_path__ + "img/feature.064159a0.svg";